const ShownSubPanelsEnum = {
  None: 'None',
  EditItem: 'EditItem',
  StatusUpdate: 'StatusUpdate',
};

export default ShownSubPanelsEnum;
